// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__cOD-o","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3lidI"};